/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_f_hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hour`)
};

const es_cr_f_hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora`)
};

const de_cr_f_hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stunde`)
};

const nl_cr_f_hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uur`)
};

const fr_cr_f_hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure`)
};

const it_cr_f_hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ora`)
};

const pt_br2_cr_f_hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora`)
};

const pt_cr_f_hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora`)
};

const ja_cr_f_hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間`)
};

const zh_cr_f_hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小时`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_f_hour = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_f_hour(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_f_hour", locale)
	if (locale === "en") return en_cr_f_hour(inputs)
	if (locale === "es") return es_cr_f_hour(inputs)
	if (locale === "de") return de_cr_f_hour(inputs)
	if (locale === "nl") return nl_cr_f_hour(inputs)
	if (locale === "fr") return fr_cr_f_hour(inputs)
	if (locale === "it") return it_cr_f_hour(inputs)
	if (locale === "pt-BR") return pt_br2_cr_f_hour(inputs)
	if (locale === "pt") return pt_cr_f_hour(inputs)
	if (locale === "ja") return ja_cr_f_hour(inputs)
	return zh_cr_f_hour(inputs)
};